import { Component, OnInit, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ReportDataTableComponent } from '../report-data-table/report-data-table.component';

@Component({
    selector: 'app-mis-dynamic-gird',
    templateUrl: '../report-data-table/report-data-table.component.html',
    styleUrls: ['./mis-dynamic-gird.component.scss'],
    standalone: false
})
export class MisDynamicGirdComponent extends ReportDataTableComponent implements OnInit {
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
    super(injector, router, route, modal)
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getDynamicHeader() {
    this.dynamicHeaderLoaded = true
    if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.list) {
      this.dynamic_header = this._currentData.resouceDef.list.dynamic_header;

      if (this.dynamic_header) {
        let args = this.dynamic_header && this.dynamic_header.datasource && this.dynamic_header.datasource.args ? this.dynamic_header.datasource.args : '';

        if (this.dynamic_header && this.dynamic_header.datasource) {
          this.baseService.get(this.dynamic_header.datasource.query_id, args, this.dynamic_header.datasource.resource, this.dynamic_header.datasource.application).subscribe(response => {

            if (response.errCode == 0 && response.resource && response.resource.length > 0) {
              response.resource[0].data.forEach(data => {
                var field = {};
                if (data[this.dynamic_header.heading] != undefined && data[this.dynamic_header.name] != undefined) {
                  field["heading"] = data[this.dynamic_header.heading];
                  field["order"] = this._currentData.currentListFields.length + 1;
                  field["name"] = data[this.dynamic_header.name];
                  field["card_tag"] = null;
                  field["sortable"] = true;
                  if (data.type != undefined && data.type != "" && data.type == "String") {
                    //set nothing
                  } else if (data.type != undefined && data.type != "" && data.type == "datetime") {
                    field["type"] = "compositeDatetime";
                    field["format"] = "fn=function(item) {return item." + data[this.dynamic_header.name] + " != undefined && item." + data[this.dynamic_header.name] + " ? item." + data[this.dynamic_header.name] + " : ''}";
                  } else {
                    field["type"] = data.type != undefined ? data.type : "";
                  }

                  if (this._currentData.currentListFields.some(code => code.name == field["name"])) {
                    console.log("Inside If");
                  } else {
                    this._currentData.currentListFields.push(field);
                  }
                }
              });
              console.log("fields====>", this._currentData.currentListFields);
              this.setData = true;
              this.callGRID = true;
            }
          });
        }
      } else {
        this.callGRID = true;
      }
    } else {
      this.callGRID = true;
    }
  }

}
